export const PAGE_SIZE = 50;

export const STATUS_LABELS = {
  CHANGED: "Изменение",
  ADDED:   "Добавление",
  DELETED: "Удаление",
};

export const STATUS_COLORS = {
  CHANGED: "blue-6",
  ADDED:   "green-6",
  DELETED: "red-6",
};

export const smetaChangeLogColumns = [
  { name: "project_info",    field: "project_info",    label: "Проект",           align: "left"   },
  { name: "location",        field: "location",        label: "Блок / Этаж",      align: "left"   },
  { name: "check_group",     field: "check_group",     label: "Группа работ",     align: "left"   },
  { name: "work_info",       field: "work_info",       label: "Работа",           align: "left"   },
  { name: "status_code",     field: "status_code",     label: "Статус",           align: "center" },
  { name: "agreement",       field: "agreement",       label: "ДС",               align: "center" },
  { name: "price",           field: "price",           label: "Цена",             align: "right"  },
  { name: "amount",          field: "amount",          label: "Кол-во",           align: "right"  },
  { name: "total_sum",       field: "total_sum",       label: "Сумма",            align: "right"  },
  { name: "rowversion",      field: "rowversion",      label: "Дата",             align: "center" },
  { name: "actions",         field: "actions",         label: "Действия",         align: "center" },
];

export const formatNum = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString("ru-RU", { maximumFractionDigits: 2 });
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
